import React from 'react';
import ReactDOM from 'react-dom/client';
import AudioPlayer from './AudioPlayer';
import './index.css';

const root = document.getElementById('root');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AudioPlayer />
  </React.StrictMode>,
);